import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { Router, ActivatedRoute } from '@angular/router';
import { InvTraveler } from 'src/models';
import { Observable } from 'rxjs';
import { AimsCommonTableHeader, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-view-travelers',
  templateUrl: './view-travelers.component.html',
  styleUrls: ['./view-travelers.component.css']
})
export class ViewTravelersComponent implements OnInit {
  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  // AimsCommonTable setup
  header: AimsCommonTableHeader[] = [
    { key: 'details', label: 'Details', type: 'button', prefix: '/inventory/traveler/', linkId: 'travelerId', filter: false },
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'description', label: 'Description', type: 'string', width: 300 },
    { key: 'revision', label: 'Revision', type: 'string' },
    { key: 'status', label: 'Status', type: 'dynamic', width: 200 },
  ];
  permissions: AimsCommonTablePermissions = {
    create: false,
    update: true,
    delete: false,
  };

  travelerStatuses = this.transferHttp.getSingle('Inventory/GetTravelerStatuses');

  //Grid
  public travelers: Observable<any> = this.transferHttp.getHot('Inventory/GetTravelers');

  constructor(private transferHttp: TransferHttpService,
      private router: Router,
      private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    window.scrollTo(0,0);
    this.travelerStatuses.pipe(take(1)).subscribe();

    this.travelers.subscribe(travelers => {
      this.showSpinner = false;
    });
  }

  public openTraveler(travelerId: number) {
    this.router.navigate([`/inventory/traveler/${travelerId}`]);
  }

  handleRowUpdate(update: TableRowUpdate): void {
    var updatedTraveler: InvTraveler = update.newRow as InvTraveler;
    this.saveTraveler(updatedTraveler);
  }

  public saveTraveler(traveler : InvTraveler): void {
    this.showSpinner = true;
    this.spinnerText = "Saving Traveler...";

    this.transferHttp.put('Inventory/SaveTraveler', traveler).subscribe(retVal => {
      this.refreshTravelers();
      this.showSpinner = false;
    });
  }

  public refreshTravelers() {
    this.travelers = this.transferHttp.getHot('Inventory/GetTravelers');
  }

}
